























































import type { WebSearchResult } from 'bits/web_search'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class ContentPickerSearchResultsWeb extends Vue {
  @Prop() results!: WebSearchResult[]
  hoveringOn: number | null = null
  select(url: string): void {
    this.$emit('select', url)
  }
  hover(index: number) {
    this.$nextTick(() => {
      this.hoveringOn = index
    })
  }
  stopHover() {
    this.hoveringOn = null
  }
}
